import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface OrnamentProps {
    className?: string
}

// Decorative gold divider: two fine lines meeting a small lotus-diamond motif.
export const Ornament: FC<OrnamentProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 160 16'
            fill='none'
            aria-hidden='true'
            className={cn('h-4 w-40 text-gold', className)}
        >
            <path d='M0 8h62' stroke='currentColor' strokeOpacity='0.55' strokeWidth='1' />
            <path d='M98 8h62' stroke='currentColor' strokeOpacity='0.55' strokeWidth='1' />
            <path d='M80 1.5 86.5 8 80 14.5 73.5 8 80 1.5Z' fill='currentColor' />
            <path d='M68 8l4-3v6l-4-3ZM92 8l-4-3v6l4-3Z' fill='currentColor' fillOpacity='0.8' />
            <circle cx='64.5' cy='8' r='1.2' fill='currentColor' />
            <circle cx='95.5' cy='8' r='1.2' fill='currentColor' />
        </svg>
    )
}
